export enum FormMode {
	Post = "post",
	Update = "update",
}
export default FormMode;
